import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import { useDinerPaymentMethods } from 'reservations/payments/hooks/useDinerPaymentMethods';

export const useAutoEnrollment = (isChecklessPaymentsEnabled: boolean) => {
  const { setValue } = useFormContext();
  const {
    lastBookingOptInChecklessPayments,
    lastBookingTipPercentage,
    setShouldAutoEnroll
  } = useDinerAccount();
  const { defaultPaymentMethodId } = useDinerPaymentMethods();

  useEffect(() => {
    if (
      isChecklessPaymentsEnabled &&
      lastBookingOptInChecklessPayments &&
      defaultPaymentMethodId
    ) {
      setValue('optInChecklessPayments', true);
      setValue('tipPercentage', lastBookingTipPercentage);
      setShouldAutoEnroll(true);
    }
  }, [
    defaultPaymentMethodId,
    lastBookingOptInChecklessPayments,
    lastBookingTipPercentage
  ]);
};
